// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__41ZyV"};